import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo MaterialLimitController (api/material-limits): per-company sell-out limits of products
// (MaterialLimitDTO). Saving goes through MaterialLimitService.SaveDTO for both insert and update.
const enc = encodeURIComponent;
const base = '/api/material-limits';

// MaterialLimitQuery { deptCode, materialCode, searchText } → MaterialLimitDTO rows
const queryPager = (query) =>
	Client.post(`${base}/query-pager`, { ...PAGE_ALL, ...(query || {}) }).then(
		pagerRows
	);
const create = (dto) => Client.post(base, dto);
const update = (limitID, dto) => Client.put(`${base}/${enc(limitID)}`, dto);
const remove = (limitID) => Client.del(`${base}/${enc(limitID)}`);
// MaterialLimitEdit.ManulChangeSoldOutState: the body is the bare limit id ([FromBody] string, so a
// JSON string; axios would send a raw string as form data).
const JSON_BODY = { headers: { 'Content-Type': 'application/json' } };
const idBody = (limitID) => JSON.stringify(String(limitID));
const manualSoldOut = (limitID) =>
	Client.post(`${base}/manual-soldout`, idBody(limitID), null, JSON_BODY);
const manualCancelSoldOut = (limitID) =>
	Client.post(
		`${base}/manual-cancel-soldout`,
		idBody(limitID),
		null,
		JSON_BODY
	);

export default {
	queryPager,
	create,
	update,
	remove,
	manualSoldOut,
	manualCancelSoldOut,
};
